import { render } from "./SafeAudit.vue?vue&type=template&id=499f5def"
import script from "./SafeAudit.vue?vue&type=script&lang=js"
export * from "./SafeAudit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__